var render = function render(){var _vm=this,_c=_vm._self._c;return _c('inline-svg',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.signingDate),expression:"signingDate"}],staticClass:"signed-icon-container",attrs:{"src":_vm.signedReceiptIcon}})
}
var staticRenderFns = []

export { render, staticRenderFns }